(function () {

  var LOTTIE_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.7.6/lottie.min.js';
  var scriptLoading = false;
  var scriptLoaded = false;

  function loadScript() {
    if (scriptLoaded || scriptLoading) return;

    scriptLoading = true;

    var s = document.createElement('script');
    s.src = LOTTIE_SRC;
    s.async = true;

    s.onload = function () {
      scriptLoaded = true;
      initLottieAnimations();
    };

    s.onerror = function () {
      scriptLoading = false;
    };

    document.head.appendChild(s);
  }

  function initLottieAnimations() {
    if (!window.lottie) return;

    var containers = document.querySelectorAll('[data-lottie-url]');

    containers.forEach(function (el) {
      if (el.dataset.lottieInitialized) return;

      window.lottie.loadAnimation({
        container: el,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: el.dataset.lottieUrl
      });

      el.dataset.lottieInitialized = "true";
    });
  }

  function observeSections() {
    var sections = document.querySelectorAll('[data-require-lottie="true"]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      loadScript();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        loadScript();
        observer.disconnect();
      });
    }, {
      rootMargin: '200px'
    });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSections);
  } else {
    observeSections();
  }

})();